// src\themes\tolica\utils\productText.ts
import { getSiteConfig } from "@/core/config/theme-config";

// فقط سایتِ اصلیِ تولیکا (tolica.xoos.ir) این قضیه رو داره، نه هر سایتی که
// از تم تولیکا استفاده می‌کنه (مثلاً وندا هم همین تم رو داره ولی دیتاش
// جابه‌جا نیست) — برای همین چک روی siteName (که per-deploy از env میاد) انجام
// می‌شه، نه روی نام تم.
const IS_TOLICA_SITE = getSiteConfig().siteName === "tolica_front";

type ProductTextFields = {
  description?: string | null;
  content?: string | null;
};

/**
 * توی دیتای سایت تولیکا، فیلد content همیشه برای بخش اول صفحه‌ی محصول
 * (خلاصه‌ی زیر قیمت) وارد می‌شه و فیلد description برای بخش دوم (آکاردئون
 * پایین صفحه) — برعکسِ چیزی که اسم فیلدها نشون می‌ده، صرف‌نظر از طول متن.
 * این تابع همون‌جایی که دیتا مصرف می‌شه (نه پخش‌شده تو چند کامپوننت) این
 * جابه‌جایی رو اعمال می‌کنه.
 */
export function getProductDisplayText(product: ProductTextFields) {
  if (!IS_TOLICA_SITE) {
    return { summaryText: product.description, detailsText: product.content };
  }
  return { summaryText: product.content, detailsText: product.description };
}
